const initBlock = async function( $block ) {
	const { Swiper } = await import( 'swiper' );
	const { Autoplay, EffectFade } = await import( 'swiper/modules' );
	await import( 'swiper/css/bundle' );

	const $slider = $block.find( '.section-about-us__bg-slider' );
	const swiperAboutUsParams = {
		modules: [Autoplay, EffectFade],
		init: false,
		loop: true,
		allowTouchMove: false,
		autoplay: {
			delay: 7000
		},
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		speed: 1500,
		spaceBetween: 0,
		slidesPerView: 1,
		slidesPerGroup: 1,
	};
	const swiperAboutUs = new Swiper( $slider[0], swiperAboutUsParams );
	swiperAboutUs.init();
};

app.loadBlock( initBlock, 'section-about-us', '.section-about-us' );

if ( module.hot ) {
	module.hot.accept();
}
